import { tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import type React from 'react'
import './NoReferenceModal.scss'

interface Props {
  onClose: () => void
  handleContinue: (e: React.MouseEvent) => void
}

function NoReferenceModal({ onClose, handleContinue }: Props) {
  return (
    <div className='no-reference-modal'>
      <div className='title'>{tr('PORTAL.COMPONENTS.NO_REFERENCE.TITLE', 'You have not entered a reference')}</div>
      <div className='content-text'>
        {tr(
          'PORTAL.COMPONENTS.NO_REFERENCE.MESSAGE',
          'The recipient might not know who is making the transfer. Do you want to continue anyway?'
        )}
      </div>

      <Button
        text={tr('FRONTEND.BUTTONS.CONTINUE', 'Continue')}
        color='primary'
        onClick={(e: React.MouseEvent) => {
          handleContinue(e)
          onClose()
        }}
      />
      <Button text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')} color='secondary' onClick={onClose} />
    </div>
  )
}

export default NoReferenceModal
